// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__2kzAC","pageSize":"Paginate_pageSize__3bb34"};